/* global __FLOWONE_LOGIN__ */

function auth() {
  if (__FLOWONE_LOGIN__) {
    const [, email, password] = __FLOWONE_LOGIN__.toString().match(/(.+);(.+)/);
    if (email) {
      return { email, password };
    }
  }

  return {
    email: "optiwaterdebug@livion.fi",
    password: "fjsaufharwejkhslduvya",
  };
}

// TESTFLOWONE ENVERA ENVIRONMENT

export default {
  servers: {
    api: "https://iot-api.testflowone.io",
    //api:  'http://localhost:3007',
    data: "https://iot-data-out.testflowone.io", //'http://localhost:3006', //
    //data: 'http://localhost:3006', //
    flowOneApi: "https://api.testflowone.io",
    //flowOneApi: "http://localhost:3007",
  },
  apiKeys: {
    flowOneApiKey: "4e20b030-d741-11e6-b338-1356991863ed",
  },
  links: {
    analyzeLink: "https://www.testflowone.io/#/analyze/",
    checkUpdateLink: "https://devicedashboard.testflowone.io/#/device/",
    serviceRequestLink: "https://dashboard.testflowone.io/servicerequest/",
  },
  ml: {
    endpointId: "2884740279284269056",
    project: "609864207304",
  },
  email: "",
  auth: auth(),
};


// ENVERA PRODUCTION ENVIRONMENT

/*export default {
  servers: {
    api: "https://iot-api.flowone.io",
    data: "https://iot-data-out.flowone.io",
    flowOneApi: "https://api.flowone.io",
  },
  apiKeys: {
    flowOneApiKey: "e3e99c90-d7d6-11e6-b406-41174c7cdd3e",
  },
  links: {
    analyzeLink: "https://www.flowone.io/#/analyze/",
    //checkUpdateLink: "https://iot.flowone.io/#/device/",
    checkUpdateLink: "https://devicedashboard.flowone.io/#/device/",
    serviceRequestLink: "https://dashboard.flowone.io/servicerequest/",
  },
  ml: {
    endpointId: "7813085646511144960",
    project: "576920927284",
  },
  email: "",
  auth: auth(),
};*/



// WEBPACK FOOTER //
// ./client/config/index.js